import { useEffect, useState, useRef } from "react";
import {
    Box,
    Card,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Stack,
    Button,
    IconButton,
    Menu,
    MenuItem,
} from "@mui/material";
import { Build as BuildIcon, MoreVert } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { FETCH_SITE_COMPANIES_2 } from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import Loader from "../../common/Loader";
import { BIGrey, BIRed } from "../../assets/helpers";
import SearchField from "../common/SearchField";
import Emptydata from "../common/Emptydata";
import InfiniteScroll from "react-infinite-scroll-component";
import { English } from "../../constant/EnglishFallback";
import { setShowmapmodal, setShowReport } from "../../redux/actions/actions";
import Pages from "../../constant/ReportModel";
import { useNavigate } from "react-router-dom";

function ManufacturerSiteSection({ color = "", manufactureDetails, id, scrollId }) {
    const { loginData, multiLanguageData, reportSuccess, showMapmodal } = useSelector((state) => state?.main);
    const currentUserId = loginData?.userInformation?.UserId ?? 0;
    const LanguageData = multiLanguageData?.Companies || {};

    const {
        TEXT_NO_RESULTS_FOUND = English.Companies.TEXT_NO_RESULTS_FOUND,
        TEXT_SITES = English.Companies.TEXT_SITES,
        TEXT_ADD_SITE = English.Companies.TEXT_ADD_SITE,
        TEXT_NO_DATA_INFO_SUBTEXT = English.Companies.TEXT_NO_DATA_INFO_SUBTEXT,
    } = LanguageData || {};

    const {
        TEXT_NO_INFO_MANUFACTURER = English.Manufacturers.TEXT_NO_INFO_MANUFACTURER,
        BUTTON_REPORT = English.Manufacturers.BUTTON_REPORT,
        TEXT_SEARCH = English.Manufacturers.TEXT_SEARCH,
    } = multiLanguageData?.Manufacturers || {};

    const debounceTimeout = useRef(null);
    const [siteData, setSiteData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [showSearchLoader, setShowSearchLoader] = useState(false);
    const [hasData, setHasData] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [allDataLoaded, setAllDataLoaded] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedSite, setSelectedSite] = useState(null);
    const open = Boolean(anchorEl);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        getInitialData();
    }, []);

    useEffect(() => {
        if (reportSuccess !== true) getInitialData();
    }, [reportSuccess]);

    useEffect(() => {
        if (showMapmodal?.select === "reload-site-list") {
            getInitialData();
        }
    }, [showMapmodal])

    const getInitialData = async () => {
        setIsLoading(true);
        await getSiteData(searchTerm, 1, "firstTimeApiCall");
        setIsLoading(false);
    };

    const onAddSiteClick = () => {
        // setOpenAddSiteModal(true);
        let mapModal = {
            open: true,
            from: "manufacture-detail",
            select: "add-site"
        };
        dispatch(setShowmapmodal(mapModal));
    }

    const getSiteData = async (searchTerm, pageNumber, firstTimeApiCall) => {
        try {
            setAllDataLoaded(true);
            const obj = {
                PageNr: pageNumber,
                NrOfRecPerPage: 20,
                FullSearch: searchTerm ?? "",
                SearchList: [{ manufacturer: true, companyId: id }],
                userId: currentUserId,
                IncludeRecordNr: true,
                SortList: [{ FieldName: "Id", Direction: "DESC" }],
                FetchAllowedRecordsOnly: true,
                TypeOfObjectReturned: "",
            };

            const res = await Postrequestcall(
                FETCH_SITE_COMPANIES_2,
                obj,
                loginData?.accessToken
            );

            if (res.status === 200) {
                let resData = res?.data?.data ?? [];

                if (pageNumber > 1) {
                    setTimeout(() => {
                        setSiteData((prev) => [...prev, ...resData]);
                    }, 300);
                } else {
                    setSiteData(resData);
                    if (firstTimeApiCall) setHasData(resData?.length > 0);
                }
            }
        } catch (error) {
            console.log("getSiteData -> Error:", error);
        } finally {
            setShowSearchLoader(false);
            setIsLoading(false);
            setAllDataLoaded(false);
        }
    };

    const increaseOffset = (callback) => {
        setPageNumber((prev) => prev + 1);
        callback(pageNumber + 1);
    };

    const onItemClick = (site) => {
        const siteData = {
            ...site,
            id: site?.siteId,  // ensure both id and siteId are present
            siteId: site?.siteId
        };
        navigate('/sites', {
            state: {
                site: siteData
            }
        });
    };

    const handleMenuClick = (event, site) => {
        setAnchorEl(event.currentTarget);
        setSelectedSite(site);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleOpenReportModal = () => {
        handleClose();
        let reportObj = {
            showReport: true,
            recordId: selectedSite?.siteId ?? 0,
            name: Pages?.site?.name,
            AppScreenId: Pages?.site?.id
        };
        dispatch(setShowReport(reportObj));
    };

    const NoInformation = () => (
        <Stack gap={1} sx={{ height: "100%" }}>
            <Button variant="text" sx={{ alignSelf: "flex-end", color: color }} onClick={onAddSiteClick}>
                {TEXT_ADD_SITE}
            </Button>
            <Box className="empty-data-card">
                <Emptydata
                    icon={<BuildIcon className="emptydata-icon" />}
                    firstText={TEXT_NO_INFO_MANUFACTURER}
                    secondText={TEXT_NO_DATA_INFO_SUBTEXT}
                />
            </Box>
        </Stack>
    );

    const renderListing = () => (
        <Box>
            <Stack gap={1}>
                {/* <Typography variant="body1" color="textSecondary">
                    {"The Sites associated with this Company"}
                </Typography> */}

                <SearchField
                    placeholder={`${TEXT_SEARCH} ${manufactureDetails?.name}'s ${TEXT_SITES}`}
                    value={searchTerm}
                    onChange={(value) => {
                        setShowSearchLoader(true);
                        setSearchTerm(value);
                        if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
                        debounceTimeout.current = setTimeout(() => {
                            getSiteData(value, 1);
                        }, 800);
                    }}
                    onSubmit={() => {
                        setShowSearchLoader(true);
                        getSiteData(searchTerm, 1);
                    }}
                    size="small"
                />
                <Button variant="text" sx={{ alignSelf: "flex-end", color: color }} onClick={onAddSiteClick}>
                    {TEXT_ADD_SITE}
                </Button>
            </Stack>

            <Stack mt={1} spacing={1}>
                {showSearchLoader ? (
                    <Stack sx={{ py: 3 }}>
                        <Loader />
                    </Stack>
                ) : siteData?.length > 0 ? (
                    <Box
                        sx={{
                            borderRadius: 2,
                            overflow: "hidden",
                        }}
                    >
                        <InfiniteScroll
                            dataLength={siteData?.length}
                            next={() => increaseOffset((page) => getSiteData(searchTerm, page))}
                            hasMore={true}
                            loader={
                                allDataLoaded ? (
                                    <Box display="flex" justifyContent="center" py={2}>
                                        <Loader />
                                    </Box>
                                ) : null
                            }
                            scrollableTarget={scrollId}
                        >
                            <List disablePadding>
                                {siteData.map((site) => (
                                    <Card
                                        key={site?.siteId ?? Math.random()}
                                        variant="outlined"
                                        sx={{
                                            borderRadius: 2,
                                            mb: 1,
                                            borderColor: "#e0e0e0",
                                            transition: "all 0.2s ease-in-out",
                                            "&:hover": {
                                                borderColor: "#c7c7c7",
                                                boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                                            },
                                        }}
                                    >
                                        <ListItem
                                            sx={{
                                                p: 0,
                                                display: "flex",
                                                alignItems: "center",
                                            }}
                                            secondaryAction={
                                                <IconButton
                                                    edge="end"
                                                    size="small"
                                                    onClick={(e) => handleMenuClick(e, site)}
                                                    sx={{
                                                        color: "text.secondary",
                                                        "&:hover": {
                                                            color: "text.primary",
                                                        },
                                                    }}
                                                >
                                                    <MoreVert fontSize="small" />
                                                </IconButton>
                                            }
                                        >
                                            <ListItemButton
                                                onClick={() => onItemClick(site)}
                                                sx={{
                                                    borderRadius: 1.5,
                                                    py: 0.75,
                                                    "&:hover": {
                                                        backgroundColor: "#f5f5f5",
                                                    },
                                                }}
                                            >
                                                <ListItemText
                                                    primary={site?.siteName}
                                                />
                                            </ListItemButton>
                                        </ListItem>
                                    </Card>
                                ))}
                            </List>
                        </InfiniteScroll>

                        <Menu
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            PaperProps={{
                                elevation: 3,
                                sx: {
                                    borderRadius: 2,
                                    minWidth: { xs: 70, sm: 80 },
                                    maxWidth: { xs: '10px', sm: 220, md: 240 },
                                    overflow: 'hidden',
                                    boxShadow: "0px 4px 10px rgba(0,0,0,0.08)",
                                },
                            }}
                            transformOrigin={{
                                horizontal: 'right',
                                vertical: 'top',
                            }}
                            anchorOrigin={{
                                horizontal: 'right',
                                vertical: 'bottom',
                            }}
                            getContentAnchorEl={null} // ensures menu aligns properly
                        >
                            <MenuItem
                                sx={{
                                    color: BIRed,
                                    fontSize: { xs: "0.85rem", sm: "0.9rem" },
                                    py: { xs: 0.1, sm: 0.5 }, // custom padding Y (reduces 8px → 4px or 6px)
                                    px: { xs: 1, sm: 2 },    // control horizontal padding
                                    "&:hover": {
                                        backgroundColor: "rgba(255, 0, 0, 0.05)",
                                    },
                                }}
                                onClick={() => handleOpenReportModal()}
                            >
                                {BUTTON_REPORT}
                            </MenuItem>
                        </Menu>
                    </Box>
                ) : (
                    <Stack
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        sx={{ color: BIGrey, py: 3 }}
                    >
                        {TEXT_NO_RESULTS_FOUND}
                    </Stack>
                )}
            </Stack>
        </Box>
    );

    return (
        <Box className="main-content-card-list">
            <Card className="pagelist-content" sx={{ p: 2 }}>
                {isLoading ? <Loader /> : hasData ? renderListing() : <NoInformation />}
            </Card>
        </Box>
    );
}

export default ManufacturerSiteSection;
